<template>
    <!--Edit-->
    <div class="container">
        <div class="page-inner">
            <div class="page-header gp-admin-page-heading">
                <h3 class="fw-bold">{{ Sinistro.sntId ? 'Alterar sinistro' : 'Novo sinistro' }}</h3>
                <ul class="breadcrumbs">
                    <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                    <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                    <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de sinistro</a></li>
                </ul>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card gp-claim-form-card">
                        <div class="card-body">
                            <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                <v-tab value="dados" class="tabinfo"
                                    style="font-size: 13px;text-transform: none !important;"><v-icon size="16">mdi-shield-alert-outline</v-icon> Dados do sinistro</v-tab>
                                <v-tab  v-if="(Sinistro?.sntId ?? 0) != 0" value="debitos" class="tabinfo"
                                    style="font-size: 13px;text-transform: none !important;"><v-icon size="16">mdi-cash-alert</v-icon> Débitos</v-tab>
                            </v-tabs>
                            <v-window v-model="tab">
                                <v-window-item value="dados" eager>
                                    <header class="gp-claim-section-header">
                                        <span><v-icon size="20">mdi-clipboard-text-outline</v-icon></span>
                                        <div>
                                            <h4>Dados do sinistro</h4>
                                            <p>Selecione o vínculo contratual e informe os dados necessários para o registro.</p>
                                        </div>
                                    </header>
                                    <v-form>
                                        <v-container>
                                              <v-row style="padding: 20px;">
                                                  <v-alert v-if="Sinistro.sntStatusObs!=''"
                                                    :text=Sinistro.sntStatusObs
                                                    title="Aviso"
                                                    type="info"
                                                ></v-alert>
                                            </v-row>
                                            <div class="row">
                                                <div class="col-md-4 col-lg-4" v-show="false">
                                                    <div class="form-group">
                                                        <label>Idenficador</label>
                                                        <input v-model="Sinistro.sntId" type="text" class="form-control"
                                                            placeholder="Id" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-lg-6" v-if="User.garid == 0">
                                                    <div class="form-group">
                                                        <label>Garantidora</label>
                                                        <v-autocomplete v-model="selectedGarantidora" :items="DadosGarantidora" item-title="garNomeEmpresa" item-value="garId"
                                                            density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                            no-data-text="Nenhum registro encontrado" :disabled="!isEditable || Sinistro.sntId!=0" @update:model-value="BuscaImobialiarias()" return-object />
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-lg-6" v-if="User.tpeid != 3">
                                                    <div class="form-group">
                                                        <label>Imobiliária</label>
                                                        <v-autocomplete v-model="selectedImobiliaria" :items="ListImobiliarias" item-title="nomeConcatenado" item-value="imoId"
                                                            density="compact" variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                                            no-data-text="Nenhum registro encontrado" :disabled="!isEditable || Sinistro.sntId!=0" @update:model-value="SelecionarConsumidor()" return-object />
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-lg-6">
                                                    <div class="form-group">
                                                        <label>Cliente</label>
                                                        <v-autocomplete v-model="selectedConsumidor" :items="ListConsumidor"
                                                            item-title="nomeConcatenado" item-value="cliId" return-object
                                                            density="compact" variant="outlined" clearable hide-details
                                                            no-data-text="Nenhum cliente encontrado"
                                                            :disabled="!isEditable || Sinistro.sntId != 0 || !selectedImobiliaria"
                                                            :placeholder="selectedImobiliaria ? 'Digite para pesquisar' : 'Selecione a imobiliária'"
                                                            @update:model-value="SelecionarPedidos()" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6 col-lg-6">
                                                    <div class="form-group">
                                                        <label>Contratação</label>
                                                        <select v-model="selectedPedido" :disabled="!isEditable || Sinistro.sntId!=0"
                                                            @change="SelecionarEnderecoPedido()"
                                                            class="form-select form-control">
                                                            <option :value=null>Selecione</option>
                                                            <option v-for="optionTipo in ListPedidos"
                                                                :key="optionTipo.pedId" :value="optionTipo">{{
                                                                    optionTipo.nomeConcatenado }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                 <div class="col-md-6 col-lg-6" v-if="ListTipoSinistro!=''">
                                                    <div class="form-group">
                                                        <label>Tipo Sinistro</label>
                                                        <select v-model="selectedTipoSinistro" :disabled="!isEditable || Sinistro.sntId!=0"
                                                            @change="SelecionarEnderecoPedido()"
                                                            class="form-select form-control">
                                                            <option :value=null>Selecione</option>
                                                            <option v-for="optionTipo in ListTipoSinistro"
                                                                :key="optionTipo.tsnId" :value="optionTipo">{{
                                                                    optionTipo.tsnNome }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>

                                            </div>
                                            <v-row v-if="PedidosEndereco != '' && ListaDocumentos != ''">
                                                <v-col cols="12" md="6">
                                                    <section class="gp-claim-info-card">
                                                        <header class="gp-claim-info-card__header">
                                                            <span><v-icon size="18">mdi-map-marker-outline</v-icon></span>
                                                            <div><h5>Endereço da contratação</h5><p>Imóvel vinculado ao sinistro.</p></div>
                                                        </header>
                                                        <div class="gp-claim-info-card__body">
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Endereço:</strong> {{
                                                                    PedidosEndereco[0].pdcEndereco
                                                                }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                    PedidosEndereco[0].pdcComplemento }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cidade/UF:</strong> {{
                                                                    PedidosEndereco[0].pdcCidade }} /
                                                                {{ PedidosEndereco[0].pdcEstado }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Bairro:</strong> {{
                                                                    PedidosEndereco[0].pdcBairro
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>CEP:</strong> {{
                                                                    PedidosEndereco[0].pdcCep }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Tipo Imóvel:</strong> {{
                                                                    PedidosEndereco[0].pdcTipo
                                                                }} {{ PedidosEndereco[0].pdcResidencialTipo
                                                                }}
                                                            </p>
                                                        </div>
                                                    </section>
                                                </v-col>
                                                <v-col cols="12" md="6">
                                                    <section class="gp-claim-info-card gp-claim-documents-card">
                                                    <header class="gp-claim-info-card__header">
                                                        <span><v-icon size="18">mdi-file-document-multiple-outline</v-icon></span>
                                                        <div><h5>Documentos do sinistro</h5><p>Descrição e arquivos comprobatórios.</p></div>
                                                    </header>
                                                    <div class="gp-claim-info-card__body">
                                                    <v-row>
                                                        <v-col cols="12" md="12">
                                                            <div class="form-group">
                                                                <label>Descrição</label>
                                                                <input v-model="Sinistro.sntDescricao" type="text" :disabled="!isEditable || Sinistro.sntId!=0"
                                                                    class="form-control" placeholder="Descrição" />
                                                            </div>
                                                        </v-col>
                                                        <v-col cols="12" md="4">
                                                            <label>Selecione o Tipo</label>
                                                            <select v-model="DocSelected" :disabled="!isEditable"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in ListaDocumentos"
                                                                    :key="optionTipo.docId" :value="optionTipo">{{
                                                                        optionTipo.docNome }}</option>
                                                            </select>
                                                        </v-col>
                                                        <v-col cols="12" md="5">
                                                            <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                                                PDF</label>
                                                            <v-file-input v-model="selectedFile" :disabled="!isEditable"
                                                                label="Selecione o arquivo" variant="underlined"
                                                                prepend-icon="mdi-file"
                                                                accept="image/*,application/pdf"></v-file-input>
                                                        </v-col>
                                                        <v-col cols="12" md="3">
                                                             <button v-if="Sinistro.sntId != 0" type="button" class="btn btn-info"
                                                                :disabled="!isEditable"
                                                                @click.prevent="SalvarDocumento()"
                                                                style="color:#ffffff;margin-top: 20px;">
                                                                Inserir
                                                            </button>
                                                            <button v-else type="button" class="btn btn-info"
                                                                :disabled="!isEditable"
                                                                @click.prevent="InserirDocumento()"
                                                                style="color:#ffffff;margin-top: 20px;">
                                                                Inserir
                                                            </button>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row>
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Tipo
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Documento
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Visualização
                                                                    </th>
                                                                    <th>
                                                                        Ações
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in ListaSinistroDocumentos"
                                                                    :key="index">
                                                                    <td>{{ item.docNome }}</td>
                                                                    <td>{{ item.sndNomeOriginal }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="item.sndNomeInterno != ''" icon
                                                                            @click.prevent="VisualizarDocumento(item.sndNomeInterno)"
                                                                            variant="text">
                                                                            <v-icon>mdi-file-eye</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Visualizar</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                    <td>
                                                                        <v-btn icon v-if="Sinistro.sntId == 0"
                                                                            :disabled="!isEditable"
                                                                            @click.prevent="DeleteDocumento(index,item)"
                                                                            variant="text">
                                                                            <v-icon>mdi-delete-forever-outline</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Excluir</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                    <v-row>
                                                    </v-row>
                                                    </div>
                                                    </section>
                                                </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-form>
                                </v-window-item>
                                <v-window-item  value="debitos" eager>
                                    <header class="gp-claim-section-header">
                                        <span><v-icon size="20">mdi-cash-multiple</v-icon></span>
                                        <div>
                                            <h4>Débitos do sinistro</h4>
                                            <p>Cadastre vencimentos, valores e os respectivos documentos.</p>
                                        </div>
                                    </header>
                                    <v-form>
                                        <v-container>
                                            <v-row>
                                                  <v-col cols="12" md="2">
                                                  <label>Valor Débito</label>
                                                   <input v-model="SinistroDebito.sdbValorDebito" v-decimal :disabled="!isEditable" class="form-control" placeholder="Valor Débito" />
                                               </v-col>
                                               <v-col cols="12" md="2">
                                                  <label>Vencimento Débito</label>
                                                   <input v-model="SinistroDebito.sdbDtDebito" type="date" :disabled="!isEditable" class="form-control" placeholder="Vencimento Débito" />
                                               </v-col>
                                                    <v-col cols="12" md="3">
                                                    <label>Selecione o Tipo</label>
                                                    <select v-model="DocSelectedDebito" :disabled="!isEditable"
                                                        class="form-select form-control">
                                                        <option :value=null>Selecione</option>
                                                        <option v-for="optionTipo in ListaDebitoDocumentos"
                                                            :key="optionTipo.docId" :value="optionTipo">{{
                                                                optionTipo.docNome }}</option>
                                                    </select>
                                                </v-col>
                                                    <v-col cols="12" md="3">
                                                    <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                                        PDF</label>
                                                    <v-file-input v-model="selectedFileDebito" :disabled="!isEditable"
                                                        label="Selecione o arquivo" variant="underlined"
                                                        prepend-icon="mdi-file"
                                                        accept="image/*,application/pdf"></v-file-input>
                                                </v-col>
                                                <v-col cols="12" md="2">
                                                    <button type="button" class="btn btn-info" :disabled="!isEditable"
                                                        @click.prevent="InserirDocumentoDebito()"
                                                        style="color:#ffffff;margin-top: 20px;">
                                                        Inserir
                                                    </button>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                            <v-table>
                                                <thead>
                                                    <tr>
                                                    <th class="text-left">Data</th>
                                                    <th class="text-left">Tipo</th>
                                                    <th class="text-left">Valor Débito</th>
                                                    <th class="text-left">Visualização</th>
                                                    <th>Ações</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="item in ListaDebitos" :key="item.sdbId">
                                                    <td>{{ formattedDate(item.sdbDtDebitoFmt) }}</td>
                                                    <td>{{ item.docNome }}</td>
                                                    <td>{{ formatarValor(item.sdbValorDebito) }}</td>
                                                    <td style="text-align:center;">
                                                        <v-btn
                                                        v-if="item.sddNomeInterno"
                                                        icon
                                                        @click.prevent="VisualizarDocumento(item.sddNomeInterno)"
                                                        variant="text"
                                                        >
                                                        <v-icon>mdi-file-eye</v-icon>
                                                        <v-tooltip activator="parent" location="top">Visualizar</v-tooltip>
                                                        </v-btn>
                                                    </td>

                                                    <td>
                                                        <v-btn
                                                        icon
                                                        :disabled="!isEditable"
                                                        @click.prevent="DeleteDocumentoDebito(index, item)"
                                                        variant="text"
                                                        >
                                                        <v-icon>mdi-delete-forever-outline</v-icon>
                                                        <v-tooltip activator="parent" location="top">Excluir</v-tooltip>
                                                        </v-btn>
                                                    </td>
                                                    </tr>
                                                </tbody>
                                                </v-table>

                                            </v-row>
                                            <v-row style="padding-top: 60px;">
                                                <!--v-col cols="12" md="12" style="text-align: right;" v-if="ListaSinistroDebitoDocumentos.filter(x=> x.docId == 4).length == 0">
                                                    <div class="form-group" style="float: right;">
                                                            <div class="form-check">
                                                            <input
                                                                v-model="checkboxAceite"
                                                                type="checkbox"
                                                                class="form-check-input"
                                                                id="checkboxAceite"
                                                            />
                                                            <label class="form-check-label" for="checkboxAceite">Concordo <a href="#" @click.prevent="openDialogDocumento()">termos de Cessão de Crédito</a></label>
                                                            </div>
                                                    </div>
                                                </!--v-col-->
                                                <v-col cols="12" md="12" style="text-align: right;">
                                                    <button type="button" class="btn btn-black" style="color:#ffffff;"
                                                        :disabled="!PodeEnviarAprovacao"
                                                        @click.prevent="EnvioAprovacao()">
                                                        <span v-if="EnviandoAprovacao" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                        {{ EnviandoAprovacao ? 'Enviando...' : 'Enviar para Aprovação Garantidora' }}
                                                    </button>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-form>
                                </v-window-item>
                            </v-window>
                        </div>
                    </div>
                </div>
                <div class="card-action gp-admin-actions gp-detail-actions" v-if="tab == 'dados'" style="text-align: center;">
                    <button type="button" class="btn btn-success" v-if="Sinistro.sntId == 0" style="color:#ffffff;" @click="AddSinistro()">
                        Cadastrar Sinistro
                    </button>
                     <button type="button" class="btn btn-danger" v-if="Sinistro.sstIdAtual == 10" style="color:#ffffff;" @click="CancelarSinistro()">
                        Cancelar Sinistro
                    </button>
                </div>
            </div>
        </div>
    </div>
         <!--modal Documento -->
        <v-row justify="center">
            <v-dialog v-model="dialogDocumento" class="controlcelEnd" transition="dialog-bottom-transition" width="auto">
                <v-card>
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">{{ ModeloContrato.cmcNome}}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                  <v-col cols="12" md="12">
                                     <p v-html="ModeloContrato.cmcTexto1.replaceAll('[NumeroSinistro]', this.Sinistro.sntCodigo).replaceAll('[GarandoraRazao]',this.Sinistro.garNome)"></p>
                                     <p v-html="ModeloContrato.cmcTexto2"></p>
                                  </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="dialogDocumento = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
</template>

<script>
import axios from 'axios'
import { personalizarEmailGarantidora } from '../../utils/guarantorEmail'
import EasyDataTable from 'vue3-easy-data-table'
import moment from 'moment'
import { useRoute } from 'vue-router'

export default {
  name: 'CadastroSinistrosView',
  components: {
    EasyDataTable,
    moment
  },
  setup () {
    const route = useRoute()
    const id = route.params.id
    return {
      id
    }
  },
  data: () => ({
    tab: null,
    User: {
      garid: 0,
      tpeid: 0,
      pesid: 0,
      cusid: 0
    },
    searchValue: '',
    NomeTela: 'Sinistros',
    InfoTela: 'Cadastro de Sinistro',
    MostraGrid: true,
    headers: [],
    Sinistro: {
      sntId: 0,
      sntIdCript: '',
      tsnId: 0,
      sntCodigo: '',
      sntDescricao: '',
      sntDtinclusao: '',
      cusId: null,
      imoId: null,
      garId: null,
      pedId: null,
      sstIdAtual: null,
      sntStatusObs: ''
    },
    SinistroDocumento: {
      sndId: 0,
      sndIdCript: '',
      sntId: 0,
      cusId: null,
      sndDtInclusao: '',
      sndNomeOriginal: '',
      sndNomeInterno: '',
      docId: null,
      docNome: ''
    },
    SinistroDebito: {
      sdbId: 0,
      sdbIdCript: '',
      sntId: 0,
      cusId: null,
      sdbDtInclusao: '',
      sdbValorDebito: 0,
      sdbDtDebito: '',
      sdbAprovado: false
    },
    SinistroDebitoDocumento: {
      sddId: 0,
      sddIdCript: '',
      sdbId: 0,
      cusId: null,
      sddDtInclusao: '',
      sddNomeOriginal: '',
      sddNomeInterno: '',
      docId: null,
      docNome: '',
      sdbValorDebito: '',
      sdbDtDebito: ''
    },
    ListSinistrosGeral: [],
    SituacoesSinistro: [],
    ListTipoSinistro: [],
    selectedTipoSinistro: null,
    // garantidoras
    DadosGarantidora: [],
    selectedGarantidora: null,
    // Imobiliarias
    ListImobiliariaGeral: [],
    selectedImobiliaria: null,
    ListImobiliarias: [],
    // Imobliarias
    // consumidor
    selectedConsumidor: null,
    ListConsumidor: [],
    // consumidor
    // pedidos
    ListPedidos: [],
    selectedPedido: null,
    // pedidoendereco
    PedidosEndereco: [],
    // documentos
    selectedFile: '',
    selectedFileDebito: '',
    DocSelected: null,
    DocSelectedDebito: null,
    ListaDocumentos: [],
    ListaDebitoDocumentos: [],
    ListaSinistroDocumentos: [],
    ListaSinistroDebitoDocumentos: [],
    checkboxAceite: false,
    dialogDocumento: false,
    ModeloContrato: {},
    ConfiguraSinistroGar: [],
    ListaDebitos: [],
    EnviandoAprovacao: false
  }),
  computed: {
    isEditable () {
      return this.Sinistro && (this.Sinistro.sntId == 0 || Number(this.Sinistro.sstIdAtual) === 10)
    },
    PodeEnviarAprovacao () {
      return this.isEditable &&
                !this.EnviandoAprovacao &&
                Number(this.Sinistro?.sntId || 0) > 0 &&
                (this.ListaDebitos || []).length > 0
    }
  },
  methods: {
    onReady (editor) {
      // Insert the toolbar before the editable area.
      editor.ui.getEditableElement().parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      )
    },
    preprocessData (data) {
      return data.map(item => {
        return {
          ...item,
          proOrdem: parseInt(item.proOrdem)
        }
      })
    },
    EditCancel () {
      this.$router.push('/listasinistros')
    },
    formattedDate (value) {
      if (value != null || value != '') {
        return this.$moment(value).format('DD/MM/YYYY')
      } else {
        return ''
      }
    },
    formatarValor (valor) {
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    },
    async Uploadpdf (dadosContrato) {
      const uploadResult = await axios.post('/Telas/CadastroSinistros/uploadContratoPdf', dadosContrato)
      return uploadResult.data.nameFile
    },
    async UploadImg (value) {
      const formData = new FormData()
      formData.append('file', value)
      const uploadResult = await axios.post('/Telas/CadastroSinistros/upload', formData)
      return uploadResult
    },
    buildFileUrl (path) {
      if (!path) return ''
      const rel = String(path).replace(/\\/g, '/') // normaliza separadores
      const base = this.$imgURL
      return `${base}/Telas/CadastroSinistros/GetFileByParam?param=${encodeURIComponent(rel)}`
    },
    openInNewTab (path) {
      const url = this.buildFileUrl(path)
      if (!url) return
      window.open(url, '_blank', 'noopener,noreferrer') // nova aba
    },
    VisualizarDocumento (item) {
      if (item) {
        this.openInNewTab(item)
      }
    },
    // sinistro
    async AddSinistro () {
      // valida se todos os docId requeridos estão presentes
      const temTodos = (this.ListaDocumentos || []).every(req =>
        (this.ListaSinistroDocumentos || []).some(s =>
          String(s.docId) === String(req.docId)
        )
      )

      // validações (early return)
      if (!this.selectedGarantidora) return this.$mensagemAviso('Selecione Garantidora.')
      if (!this.selectedImobiliaria) return this.$mensagemAviso('Selecione Imobiliária.')
      if (!this.selectedConsumidor) return this.$mensagemAviso('Selecione Cliente.')
      if (!this.selectedPedido) return this.$mensagemAviso('Selecione Contratação.')
      if (!this.selectedTipoSinistro) return this.$mensagemAviso('Selecione Tipo Sinistro.')
      if (!this.Sinistro?.sntDescricao) return this.$mensagemAviso('Descrição obrigatória.')
      if (!temTodos) return this.$mensagemAviso('Faltam documentos a serem inseridos.')

      try {
        // monta dados do sinistro
        this.Sinistro.tsnId = this.selectedTipoSinistro.tsnId
        this.Sinistro.sntCodigo = String(this.selectedGarantidora.garId) + moment().format('DDMMYYYYHHmmss')
        this.Sinistro.sntDtinclusao = moment().format('YYYY-MM-DDTHH:mm:ss')
        this.Sinistro.cusId = this.User?.cusid ?? this.User?.cusId
        this.Sinistro.imoId = this.selectedImobiliaria.imoId
        this.Sinistro.garId = this.selectedGarantidora.garId
        this.Sinistro.pedId = this.selectedPedido.pedId
        this.Sinistro.sstIdAtual = 10

        // cria o sinistro
        const resp = await axios.post('/Telas/CadastroSinistros/AddSinistro', this.Sinistro)
        const novoId = resp?.data
        if (!novoId || novoId <= 0) {
          this.$mensagemErro?.('Falha ao incluir sinistro.')
          return
        }
        this.Sinistro.sntId = novoId

        const dt = moment().format('YYYY-MM-DDTHH:mm:ss');

        // garante reatividade no Vue 2 (se precisar)
        (this.ListaSinistroDocumentos || []).forEach(el => { if (el.sndId == null) el.sndId = 0 })

        // salva documentos SEQUENCIALMENTE (um por vez)
        for (const [i, element] of (this.ListaSinistroDocumentos || []).entries()) {
          const payload = {
            sndId: 0,
            sntId: this.Sinistro.sntId,
            cusId: this.User?.cusid ?? this.User?.cusId,
            sndDtInclusao: dt,
            sndNomeOriginal: element.sndNomeOriginal,
            sndNomeInterno: element.sndNomeInterno,
            docId: element.docId
          }

          const resp = await axios.post('/Telas/CadastroSinistros/AddSinistroDocumento', payload)

          // pode vir número puro ou objeto { sndId: ... }
          const novoId = (resp?.data && typeof resp.data === 'object') ? resp.data.sndId : resp?.data

          if (novoId > 0) {
            if (this.$set) this.$set(this.ListaSinistroDocumentos[i], 'sndId', novoId) // Vue 2
            else this.ListaSinistroDocumentos[i].sndId = novoId // Vue 3
          } else {
            console.warn('Falha ao salvar documento', element, resp?.data)
          }
        }
        this.AddHistoricoStatus(10)
        // só aqui mostra a mensagem
        this.$mensagemAvisoSucesso('Sinistro incluído. Adicione as informações do débito na aba Débitos.')
        this.tab = 'debitos'
      } catch (err) {
        console.error('Erro ao incluir sinistro/documentos:', err)
        this.$mensagemErro?.('Falha ao incluir sinistro ou documentos.')
      }
    },
    // imobiliraria
    async BuscaImobialiarias () {
      const _validaConfigSinistroGar = this.ConfiguraSinistroGar.filter(x => x.garId == this.selectedGarantidora.garId)

      if (_validaConfigSinistroGar == null || _validaConfigSinistroGar == '') {
        return this.$mensagemAvisoConfirm('Dados Configuração Sinistro Tela Garantidora (aba Sinistro) devem ser preenchidos.')
      } else if (_validaConfigSinistroGar != '' && _validaConfigSinistroGar != null) {
        if (_validaConfigSinistroGar[0].gscEmailAprovacao === '' || _validaConfigSinistroGar[0].gscEmailAprovacao === null) {
          return this.$mensagemAvisoConfirm('Dados Configuração Sinistro Tela Garantidora (aba Sinistro) devem ser preenchidos. E-mail Aprovação Obrigatório.')
        } else if (_validaConfigSinistroGar[0].gscEmailPagamento === '' || _validaConfigSinistroGar[0].gscEmailPagamento === null) {
          return this.$mensagemAvisoConfirm('Dados Configuração Sinistro Tela Garantidora (aba Sinistro) devem ser preenchidos. E-mail Pagamento Obrigatório.')
        } else if (_validaConfigSinistroGar[0].gscEmailCobranca === '' || _validaConfigSinistroGar[0].gscEmailCobranca === null) {
          return this.$mensagemAvisoConfirm('Dados Configuração Sinistro Tela Garantidora (aba Sinistro) devem ser preenchidos. E-mail Cobrança Obrigatório.')
        } else if (_validaConfigSinistroGar[0].gscEmailFinanceiro === '' || _validaConfigSinistroGar[0].gscEmailFinanceiro === null) {
          return this.$mensagemAvisoConfirm('Dados Configuração Sinistro Tela Garantidora (aba Sinistro) devem ser preenchidos. E-mail Financeiro Obrigatório.')
        } else if (_validaConfigSinistroGar[0].gscEmailJuridico === '' || _validaConfigSinistroGar[0].gscEmailJuridico === null) {
          return this.$mensagemAvisoConfirm('Dados Configuração Sinistro Tela Garantidora (aba Sinistro) devem ser preenchidos. E-mail Jurírico Obrigatório.')
        } else if (_validaConfigSinistroGar[0].gscMulta === '' || _validaConfigSinistroGar[0].gscMulta === null) {
          return this.$mensagemAvisoConfirm('Dados Configuração Sinistro Tela Garantidora (aba Sinistro) devem ser preenchidos. Multa Obrigatório.')
        } else if (_validaConfigSinistroGar[0].gscJuroDiario === '' || _validaConfigSinistroGar[0].gscJuroDiario === null) {
          return this.$mensagemAvisoConfirm('Dados Configuração Sinistro Tela Garantidora (aba Sinistro) devem ser preenchidos. Juro Diário Obrigatório.')
        } else {
          this.selectedImobiliaria = null
          this.ListImobiliariaGeral = []
          this.ListConsumidor = []
          this.selectedConsumidor = null
          this.ListPedidos = []
          this.selectedPedido = null
          this.PedidosEndereco = []
          this.selectedTipoSinistro = null
          this.ListaDocumentos = []
          this.ListaSinistroDocumentos = []
          if (this.selectedGarantidora != '' && this.selectedGarantidora != null) {
            await axios.get('/Telas/CadastroSinistros/GetByGarIdParIdImobiliaria/' + this.selectedGarantidora.garId + '/0')
              .then(response => {
                this.ListImobiliariaGeral = response.data
                this.ListImobiliarias = this.ListImobiliariaGeral.filter(x => x.imoVisivel).sort((a, b) =>
                  a.imoNomeEmpresa.localeCompare(
                    b.imoNomeEmpresa,
                    'pt',
                    { sensitivity: 'base' }
                  )
                )
                this.ListImobiliarias = this.ListImobiliarias.map(item => {
                  return {
                    ...item,
                    nomeConcatenado: `${item.imoId} - ${item.imoNomeEmpresa} - ${item.imoDocumento}`
                  }
                })

                if (this.id != '') {
                  this.selectedImobiliaria = this.ListImobiliarias.filter(x => x.imoId == this.Sinistro.imoId)[0]
                  this.SelecionarConsumidor()
                } else {
                  if (this.User.tpeid == 3) {
                    this.ListImobiliarias = this.ListImobiliarias.filter(x => x.imoId == this.User.pesid)
                    this.selectedImobiliaria = this.ListImobiliarias[0]
                    this.SelecionarConsumidor()
                  }
                }
              })
          }
        }
      }
    },
    // consumidor
    async SelecionarConsumidor () {
      this.ListConsumidor = []
      this.selectedConsumidor = null
      this.ListPedidos = []
      this.selectedPedido = null
      this.PedidosEndereco = []
      this.selectedTipoSinistro = null
      this.ListaDocumentos = []
      this.ListaSinistroDocumentos = []
      if (this.selectedImobiliaria != '' && this.selectedImobiliaria != null) {
        axios.get('/Telas/CadastroSinistros/GetByGarIdImoIdClientes/0/' + this.selectedImobiliaria.imoId)
          .then(response => {
            this.ListConsumidor = response.data.filter(x => x.cliAtivo).sort((a, b) =>
              a.cliNomeEmpresa.localeCompare(
                b.cliNomeEmpresa,
                'pt',
                { sensitivity: 'base' }
              )
            )
            this.ListConsumidor = this.ListConsumidor.map(item => {
              return {
                ...item,
                nomeConcatenado: `${item.cliId} - ${item.cliNomeEmpresa} - ${item.cliDocumento}`
              }
            })

            if (this.id != '') {
              this.selectedConsumidor = this.ListConsumidor.filter(x => x.cliId == this.Sinistro.cliId)[0]
              this.SelecionarPedidos()
            } else {
              if (this.User.tpeid == 3) {
                this.SelecionarPedidos()
              }
            }
          })
      }
    },
    // pedidos
    async SelecionarPedidos () {
      this.ListPedidos = []
      this.selectedPedido = null
      this.PedidosEndereco = []
      this.selectedTipoSinistro = null
      this.ListaDocumentos = []
      this.ListaSinistroDocumentos = []
      if (this.selectedConsumidor != '' && this.selectedConsumidor != null) {
        await axios.get('/Telas/CadastroSinistros/GetAllByCliIdPedidos/' + this.selectedConsumidor.cliId)
          .then(response => {
            this.ListPedidos = response.data.filter(x => x.pspId == 3 || x.pspId == 12 || x.pspId == 16 || x.pspId == 17 || x.pspId == 10)
            this.ListPedidos = this.ListPedidos.map(item => {
              const nomeCliente = this.selectedConsumidor?.cliNomeEmpresa || ''
              const documentoCliente = this.selectedConsumidor?.cliDocumento || ''
              return {
                ...item,
                nomeConcatenado: `${item.pedId} - ${nomeCliente} - ${documentoCliente} - ${this.formattedDate(item.pedDataPedido)} - ${item.pedSituacaoPedido}`
              }
            })
          })

        if (this.id != '') {
          this.selectedPedido = this.ListPedidos.filter(x => x.pedId == this.Sinistro.pedId)[0]
          this.SelecionarEnderecoPedido()
          this.CarregarDocumento()
        }
      }
    },
    // enderecoPedido
    async SelecionarEnderecoPedido () {
      this.PedidosEndereco = []
      if (this.id == '') {
        this.ListaDocumentos = []
        this.ListaSinistroDocumentos = []
      }
      if (this.selectedPedido != '' && this.selectedPedido != null) {
        await axios.get('/Telas/CadastroSinistros/GetAllByPedIdEndereco/' + this.selectedPedido.pedId)
          .then(response => {
            this.PedidosEndereco = response.data
            // console.log('PedidosEndereco')
            // console.log(this.PedidosEndereco)
          })
          .catch(error => {
            console.error(error)
          })

        if (this.id != '') {
          this.selectedTipoSinistro = this.ListTipoSinistro.filter(x => x.tsnId == this.Sinistro.tsnId)[0]
        }
        if (this.selectedTipoSinistro == '' || this.selectedTipoSinistro == null) {
          return
        }
        await axios.get('/Telas/CadastroSinistros/GetByGarIdDocumentos/' + this.selectedGarantidora.garId + '/' + this.selectedTipoSinistro.tsnId)
          .then(response => {
            this.ListaDocumentos = response.data
          })
          .catch(error => {
            console.error(error)
          })

        await axios.get('/Telas/CadastroSinistros/GetByGarIdDebitoDocumentos/' + this.selectedGarantidora.garId)
          .then(response => {
            this.ListaDebitoDocumentos = response.data
          })
          .catch(error => {
            console.error(error)
          })

        await this.CarregarDocumentosUltimoSinistro()
      }
    },
    // documentos
    async InserirDocumento () {
      if (this.DocSelected == '' || this.DocSelected == null) {
        this.$mensagemAviso('Selecione o Tipo de Documento a ser enviado.')
      } else if (this.selectedFile == '' || this.selectedFile == null) {
        this.$mensagemAviso('Selecione um Documento a ser enviado.')
      } else {
        try {
          const uploadSuccess = await this.UploadImg(this.selectedFile[0])

          if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
            this.SinistroDocumento.sndNomeOriginal = this.selectedFile[0].name
            this.SinistroDocumento.sndNomeInterno = uploadSuccess.data.nameFile
            this.SinistroDocumento.sndDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss')
            this.SinistroDocumento.cusId = this.User.cusid
            this.SinistroDocumento.docId = this.DocSelected.docId
            this.SinistroDocumento.docNome = this.DocSelected.docNome

            // Adiciona cópia do documento à lista
            this.ListaSinistroDocumentos.push({ ...this.SinistroDocumento })
            // Limpa seleções
            this.selectedFile = ''
            this.SinistroDocumento = {
              sndId: 0,
              sndIdCript: '',
              sntId: 0,
              cusId: null,
              sndDtInclusao: '',
              sndNomeOriginal: '',
              sndNomeInterno: '',
              docId: null
            }
          } else {
            this.$mensagemErro('Erro inesperado ao processar o arquivo. Tente novamente.')
          }
        } catch (error) {
          // Trata erro retornado pelo backend (ex: BadRequest)
          const mensagem = error.response?.data || 'Erro ao enviar o documento.'
          this.$mensagemErro(mensagem)
        }
      }
    },
    DeleteDocumento (_index, item) {
      this.$mensagemConfirma('Tem certeza que deseja excluir?')
        .then((result) => {
          if (result.isConfirmed) {
            // Lógica para excluir o item
            if (item.sndId == 0) {
              this.ListaSinistroDocumentos.splice(_index, 1)
            } else {
              const cliam1 = item.sndId
              axios.delete(`/Telas/CadastroSinistros/DeleteSinistroDocumento/${cliam1}`)
                .then(response => {
                  if (response.status == 200) {
                    this.$mensagemAvisoSucesso('Registro Excluido.')
                    this.ListaSinistroDocumentos.splice(_index, 1)
                  }
                })
            }
          }
        })
    },
    async CarregarDocumento () {
      if (this.id != '') {
        await axios.get('/Telas/CadastroSinistros/GetBySntIdDocumentos/' + this.Sinistro.sntId)
          .then(response => {
            this.ListaSinistroDocumentos = response.data
            // console.log('this.ListaSinistroDocumentos')
            // console.log(this.ListaSinistroDocumentos)
          })
      }
    },
    async CarregarDocumentosUltimoSinistro () {
      if (this.id != '' || this.Sinistro.sntId != 0) return
      if (!this.selectedGarantidora || !this.selectedImobiliaria || !this.selectedConsumidor || !this.selectedPedido || !this.selectedTipoSinistro) return

      await axios.get(`/Telas/CadastroSinistros/GetUltimoDocumentosPorCadastro/${this.selectedGarantidora.garId}/${this.selectedImobiliaria.imoId}/${this.selectedConsumidor.cliId}/${this.selectedPedido.pedId}/${this.selectedTipoSinistro.tsnId}`)
        .then(response => {
          const documentos = response.data || []
          this.ListaSinistroDocumentos = documentos.map(item => ({
            sndId: 0,
            sndIdCript: '',
            sntId: 0,
            cusId: this.User?.cusid ?? this.User?.cusId,
            sndDtInclusao: moment().format('YYYY-MM-DDTHH:mm:ss'),
            sndNomeOriginal: item.sndNomeOriginal,
            sndNomeInterno: item.sndNomeInterno,
            docId: item.docId,
            docNome: item.docNome
          }))
        })
        .catch(error => {
          console.error(error)
        })
    },
    // documentos debito
    async InserirDocumentoDebito () {
      if (this.SinistroDebito.sdbValorDebito == '' || this.SinistroDebito.sdbValorDebito == null) return this.$mensagemAviso('Digite Valor Débito.')
      if (this.SinistroDebito.sdbDtDebito === '' || this.SinistroDebito.sdbDtDebito === null) return this.$mensagemAviso('Digite a Data do Débito.')
      const md = this.$moment(this.SinistroDebito.sdbDtDebito, 'YYYY-MM-DD', true)

      if (this.DocSelectedDebito == '' || this.DocSelectedDebito == null) {
        this.$mensagemAviso('Selecione o Tipo de Documento a ser enviado.')
      } else {
        try {
          if (this.selectedFileDebito != '' && this.selectedFileDebito != null) {
            const uploadSuccess = await this.UploadImg(this.selectedFileDebito[0])

            if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
              this.SinistroDebitoDocumento.sddNomeOriginal = this.selectedFileDebito[0].name
              this.SinistroDebitoDocumento.sddNomeInterno = uploadSuccess.data.nameFile
              this.SinistroDebitoDocumento.sddDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss')
              this.SinistroDebitoDocumento.cusId = this.User.cusid
              this.SinistroDebitoDocumento.docId = this.DocSelectedDebito.docId
              this.SinistroDebitoDocumento.docNome = this.DocSelectedDebito.docNome
              this.SinistroDebitoDocumento.sdbValorDebito = this.SinistroDebito.sdbValorDebito
              this.SinistroDebitoDocumento.sdbDtDebito = md

              // Adiciona cópia do documento à lista
              this.ListaSinistroDebitoDocumentos.push({ ...this.SinistroDebitoDocumento })
              // console.log('this.ListaSinistroDebitoDocumentos')
              // console.log(this.ListaSinistroDebitoDocumentos)

              // Limpa seleções
              this.selectedFileDebito = ''
              this.SinistroDebitoDocumento = {
                sddId: 0,
                sddIdCript: '',
                sdbId: 0,
                cusId: null,
                sddDtInclusao: '',
                sddNomeOriginal: '',
                sddNomeInterno: '',
                docId: null,
                docNome: '',
                sdbValorDebito: '',
                sdbDtDebito: ''
              }
              await this.AddSinistroDebito()
            } else {
              this.$mensagemErro('Erro inesperado ao processar o arquivo. Tente novamente.')
            }
          } else {
            this.SinistroDebitoDocumento.sddNomeOriginal = ''
            this.SinistroDebitoDocumento.sddNomeInterno = ''
            this.SinistroDebitoDocumento.sddDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss')
            this.SinistroDebitoDocumento.cusId = this.User.cusid
            this.SinistroDebitoDocumento.docId = this.DocSelectedDebito.docId
            this.SinistroDebitoDocumento.docNome = this.DocSelectedDebito.docNome
            this.SinistroDebitoDocumento.sdbValorDebito = this.SinistroDebito.sdbValorDebito
            this.SinistroDebitoDocumento.sdbDtDebito = md

            // Adiciona cópia do documento à lista
            this.ListaSinistroDebitoDocumentos.push({ ...this.SinistroDebitoDocumento })
            // console.log('this.ListaSinistroDebitoDocumentos')
            // console.log(this.ListaSinistroDebitoDocumentos)

            // Limpa seleções
            this.selectedFileDebito = ''
            this.SinistroDebitoDocumento = {
              sddId: 0,
              sddIdCript: '',
              sdbId: 0,
              cusId: null,
              sddDtInclusao: '',
              sddNomeOriginal: '',
              sddNomeInterno: '',
              docId: null,
              docNome: '',
              sdbValorDebito: '',
              sdbDtDebito: ''
            }
            await this.AddSinistroDebito()
          }
        } catch (error) {
          // Trata erro retornado pelo backend (ex: BadRequest)
          const mensagem = error.response?.data || 'Erro ao enviar o documento.'
          this.$mensagemErro(mensagem)
        }
      }
    },
    DeleteDocumentoDebito (_index, item) {
      this.$mensagemConfirma('Tem certeza que deseja excluir?')
        .then((result) => {
          if (result.isConfirmed) {
            // Lógica para excluir o item
            // console.log('item')
            // console.log(item)
            const cliam2 = item.sdbId
            axios.delete(`/Telas/CadastroSinistros/DeleteSinistroDebitoDocumento/${cliam2}`)
              .then(response => {
                if (response.status == 200) {
                  axios.delete(`/Telas/CadastroSinistros/DeleleSinistroDebito/${cliam2}`)
                    .then(response2 => {
                      if (response2.status == 200) {
                        this.$mensagemAvisoSucesso('Registro Excluido.')
                        this.tab = 'debitos' // 1) ativa tab primeiro
                        this.$nextTick() // 2) garante que DOM do tab/tabela exista

                        this.Get() // 3) busca dados
                        this.$nextTick() // 4) agora sim garante repaint da tabela
                      }
                    })
                }
              })
          }
        })
    },
    async SalvarDocumento () {
      await this.InserirDocumento()
      const dt = moment().format('YYYY-MM-DDTHH:mm:ss')
      // salva documentos SEQUENCIALMENTE (um por vez)
      for (const [i, element] of (this.ListaSinistroDocumentos.filter(x => x.sndId == 0) || []).entries()) {
        const payload = {
          sndId: 0,
          sntId: this.Sinistro.sntId,
          cusId: this.User?.cusid ?? this.User?.cusId,
          sndDtInclusao: dt,
          sndNomeOriginal: element.sndNomeOriginal,
          sndNomeInterno: element.sndNomeInterno,
          docId: element.docId
        }

        const resp = await axios.post('/Telas/CadastroSinistros/AddSinistroDocumento', payload)

        // pode vir número puro ou objeto { sndId: ... }
        const novoId = (resp?.data && typeof resp.data === 'object') ? resp.data.sndId : resp?.data

        if (novoId > 0) {
          if (this.$set) this.$set(this.ListaSinistroDocumentos[i], 'sndId', novoId) // Vue 2
          else this.ListaSinistroDocumentos[i].sndId = novoId // Vue 3
        } else {
          console.warn('Falha ao salvar documento', element, resp?.data)
        }
      }
    },
    // debitos
    async AddSinistroDebito () {
      // valida se todos os docId requeridos estão presentes
      /*   const temTodos = (this.ListaDebitoDocumentos || []).every(req =>
                (this.ListaSinistroDebitoDocumentos || []).some(s =>
                    String(s.docId) === String(req.docId)
                )
            ); */

      // validações (early return)
      /* if (this.SinistroDebito.sdbValorDebito == '' || this.SinistroDebito.sdbValorDebito == null) return this.$mensagemAviso("Digite Valor Débito.");
            if (this.SinistroDebito.sdbDtDebito === '' || this.SinistroDebito.sdbDtDebito === null) return this.$mensagemAviso("Digite a Data do Débito.");
           */ const md = this.$moment(this.SinistroDebito.sdbDtDebito, 'YYYY-MM-DD', true)

      // BLOQUEIA hoje e futuro
      if (md.startOf('day').isSameOrAfter(this.$moment().startOf('day'))) {
        return this.$mensagemAviso('A Data do Débito não pode ser hoje nem futura.')
      }
      // if (!temTodos) return this.$mensagemAviso("Faltam documentos a serem inseridos.");

      try {
        console.log('this.SinistroDebito.sdbValorDebito')
        console.log(this.SinistroDebito.sdbValorDebito)
        // monta dados do sinistro
        this.SinistroDebito.sntId = this.Sinistro.sntId
        this.SinistroDebito.cusId = this.User?.cusid ?? this.User?.cusId
        this.SinistroDebito.sdbDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss')
        this.SinistroDebito.sdbValorDebito = this.SinistroDebito.sdbValorDebito.replaceAll(',', '.')
        this.SinistroDebito.sdbDtDebito = moment(this.SinistroDebito.sdbDtDebito).format('YYYY-MM-DD')

        // cria o sinistro
        const resp = await axios.post('/Telas/CadastroSinistros/AddSinistroDebito', this.SinistroDebito)
        const novoId = resp?.data
        if (!novoId || novoId <= 0) {
          this.$mensagemErro?.('Falha ao incluir sinistro.')
          return
        }
        this.SinistroDebito.sdbId = novoId
        const dt = moment().format('YYYY-MM-DDTHH:mm:ss');

        // (opcional) garante a prop reativa no Vue 2
        (this.ListaSinistroDebitoDocumentos || []).forEach(el => { if (el.sddId == null) el.sddId = 0 })
        const documentosNovos = (this.ListaSinistroDebitoDocumentos || []).filter(x => Number(x.sddId || 0) === 0)

        // salva documentos SEQUENCIALMENTE (um por vez)
        for (const [i, element] of documentosNovos.entries()) {
          const payload = {
            sddId: 0,
            sdbId: this.SinistroDebito.sdbId,
            cusId: this.User?.cusid ?? this.User?.cusId,
            sddDtInclusao: dt,
            sddNomeOriginal: element.sddNomeOriginal,
            sddNomeInterno: element.sddNomeInterno,
            docId: element.docId
          }

          const resp = await axios.post('/Telas/CadastroSinistros/AddSinistroDebitoDocumento', payload)

          // pode vir número puro ou objeto { sddId: ... }
          let novoId = resp?.data
          if (typeof novoId === 'object' && novoId !== null) {
            novoId = novoId.sddId ?? novoId.id ?? 0
          }

          if (Number(novoId) > 0) {
            if (this.$set) this.$set(documentosNovos[i], 'sddId', Number(novoId)) // Vue 2
            else documentosNovos[i].sddId = Number(novoId) // Vue 3
          } else {
            console.warn('Falha ao salvar débito doc:', element, resp?.data)
          }
        }

        this.$mensagemAvisoSucesso?.('Débito do sinistro Salvo.')
        this.SinistroDebito.sdbValorDebito = 0
        this.ListaSinistroDebitoDocumentos = []
        this.DocSelectedDebito = null
        this.selectedFileDebito = ''

        this.tab = 'debitos' // 1) ativa tab primeiro
        await this.$nextTick() // 2) garante que DOM do tab/tabela exista

        await this.Get() // 3) busca dados
        await this.$nextTick() // 4) agora sim garante repaint da tabela
      } catch (err) {
        console.error('Erro ao incluir sinistro/documentos:', err)
        this.$mensagemErro?.('Falha ao incluir documentos.')
      }
    },
    async PutSinistroDebito () {
      // valida se todos os docId requeridos estão presentes
      const temTodos = (this.ListaDebitoDocumentos || []).every(req =>
        (this.ListaSinistroDebitoDocumentos || []).some(s =>
          String(s.docId) === String(req.docId)
        )
      )

      // validações (early return)
      if (this.SinistroDebito.sdbValorDebito == '' && this.SinistroDebito.sdbValorDebito == null) return this.$mensagemAviso('Digite Valor Débito.')
      if (this.SinistroDebito.sdbDtDebito == '' && this.SinistroDebito.sdbDtDebito == null) return this.$mensagemAviso('Digite a Data do Débito.')
      if (!temTodos) return this.$mensagemAviso('Faltam documentos a serem inseridos.')

      try {
        console.log('this.SinistroDebito.sdbValorDebito2')
        console.log(this.SinistroDebito.sdbValorDebito)
        // monta dados do sinistro
        this.SinistroDebito.sntId = this.Sinistro.sntId
        this.SinistroDebito.cusId = this.User?.cusid ?? this.User?.cusId
        this.SinistroDebito.sdbDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss')
        this.SinistroDebito.sdbValorDebito = this.SinistroDebito.sdbValorDebito.replaceAll(',', '.')
        this.SinistroDebito.sdbDtDebito = moment(this.SinistroDebito.sdbDtDebito).format('YYYY-MM-DD')

        // cria o sinistro
        const resp = await axios.put('/Telas/CadastroSinistros/PutSinistroDebito', this.SinistroDebito)

        const dt = moment().format('YYYY-MM-DDTHH:mm:ss');

        // (opcional) garante a prop reativa no Vue 2
        (this.ListaSinistroDebitoDocumentos.filter(x => x.sddId == 0) || []).forEach(el => { if (el.sddId == null) el.sddId = 0 })

        // salva documentos SEQUENCIALMENTE (um por vez)
        for (const [i, element] of (this.ListaSinistroDebitoDocumentos.filter(x => x.sddId == 0) || []).entries()) {
          const payload = {
            sddId: 0,
            sdbId: this.SinistroDebito.sdbId,
            cusId: this.User?.cusid ?? this.User?.cusId,
            sddDtInclusao: dt,
            sddNomeOriginal: element.sddNomeOriginal,
            sddNomeInterno: element.sddNomeInterno,
            docId: element.docId
          }

          const resp = await axios.post('/Telas/CadastroSinistros/AddSinistroDebitoDocumento', payload)

          // pode vir número puro ou objeto { sddId: ... }
          let novoId = resp?.data
          if (typeof novoId === 'object' && novoId !== null) {
            novoId = novoId.sddId ?? novoId.id ?? 0
          }

          if (Number(novoId) > 0) {
            if (this.$set) this.$set(this.ListaSinistroDebitoDocumentos[i], 'sddId', Number(novoId)) // Vue 2
            else this.ListaSinistroDebitoDocumentos[i].sddId = Number(novoId) // Vue 3
          } else {
            console.warn('Falha ao salvar débito doc:', element, resp?.data)
          }
        }

        // se quiser mensagem somente ao final:
        this.$mensagemAvisoSucesso?.('Débito do sinistro Salvo.')
        this.Get()
        this.tab = 'debitos'
      } catch (err) {
        console.error('Erro ao incluir sinistro/documentos:', err)
        this.$mensagemErro?.('Falha ao incluir documentos.')
      }
    },
    async CarregarDebitoDocumento () {
      if (this.id != '') {
        await axios.get('/Telas/CadastroSinistros/GetBySdbIdDebitoDocumentos/' + 0)
          .then(response => {
            this.ListaSinistroDebitoDocumentos = response.data
          })
      }
    },
    async EnvioAprovacao () {
      if (!this.PodeEnviarAprovacao) return
      this.EnviandoAprovacao = true
      // altera o sinistro
      this.Sinistro.sstIdAtual = 20
      const result = await axios.put('/Telas/CadastroSinistros/PutSinistro', this.Sinistro)
        .catch(err => {
          this.EnviandoAprovacao = false
          console.error('Erro ao enviar sinistro para aprovação:', err)
          this.$mensagemErro?.('Falha ao enviar sinistro para aprovação.')
          return null
        })
      if (!result) return
      const Id = result?.data
      if (Id > 0) {
        await this.AddHistoricoStatus(20)
        let aviso = 'Sinistro enviado para aprovação.'
        try {
          await this.EnviaAvisoGarantidora()
        } catch (erro) {
          aviso += ' ' + (erro.message || 'Não foi possível confirmar os avisos por e-mail.')
        }
        this.$router.push('/listasinistros')
        this.$mensagemAviso(aviso)
      } else {
        this.EnviandoAprovacao = false
      }
    },
    // HistoricoStatus
    async AddHistoricoStatus (item) {
      const _hist = {
        shsId: 0,
        sntId: this.Sinistro.sntId,
        shsDtInclusao: moment().format('YYYY-MM-DDTHH:mm:ss'),
        sstId: item,
        cusId: this.User.cusid,
        shsStatusObs: ''
      }
      await axios.post('/Telas/CadastroSinistros/AddSinistroHistoricoStatus', _hist)
    },
    async EnviaAvisoGarantidora () {
      const garId = this.selectedGarantidora?.garId || this.Sinistro.garId
      const config = this.ConfiguraSinistroGar.find(item => Number(item.garId) === Number(garId))
      const destinatarios = [...new Set([this.selectedGarantidora?.garEmail, config?.gscEmailAprovacao]
        .flatMap(valor => String(valor || '').split(/[;,]/))
        .map(email => email.trim().toLowerCase()).filter(Boolean))]
      if (!destinatarios.length) throw new Error('Não há e-mail geral nem e-mail de aprovação cadastrado para o aviso.')
      const { data: modelo } = await axios.get(`/Telas/CadastroSinistros/GetByIdMensagemPadrao/20?garId=${garId}`)
      if (!modelo?.mpdTexto) throw new Error('Mensagem de cadastro de sinistro não encontrada.')
      const email = await personalizarEmailGarantidora({
        nomeDe: this.selectedImobiliaria.imoNomeEmpresa,
        nomePara: this.selectedGarantidora.garNomeEmpresa,
        assunto: 'Cadastro de Sinistro: ' + this.Sinistro.sntCodigo,
        emailResposta: this.selectedImobiliaria.imoEmail,
        textoEmail: modelo.mpdTexto.replace('[CodSinistro]', this.Sinistro.sntCodigo)
          .replace('[NovoStatus]', 'Aguardando Aprovação'),
        listAnexos: null
      }, garId, this.$imgURL, this.$GarantePayLinkAcesso, this.$GarantePayEmail)
      const falhas = []
      for (const destinatario of destinatarios) {
        try {
          const { data } = await axios.post('/Telas/CadastroSinistros/Enviamail', { ...email, destinatario })
          if (data !== 1) throw new Error()
        } catch {
          falhas.push('Envio não confirmado para ' + destinatario + '.')
          continue
        }
        try {
          await axios.post('/Telas/CadastroSinistros/AddSinistroEnvioEmail', {
            seeId: 0, sntId: this.Sinistro.sntId, seeDtEnvio: moment().format('YYYY-MM-DDTHH:mm:ss'),
            seeEmailDestinatario: destinatario, seeTipoEnvio: modelo.mpdNome
          })
        } catch {
          falhas.push('Aviso encaminhado para ' + destinatario + ', mas não registrado no histórico.')
        }
      }
      if (falhas.length) throw new Error(falhas.join(' '))
    },
    async openDialogDocumento () {
      this.dialogDocumento = true
    },
    async CancelarSinistro () {
      this.$mensagemSimNao('Aviso: O cancelamento do sinistro é irreversível, confirma cancelamento?')
        .then((result) => {
          if (result.isConfirmed) {
            this.Sinistro.sstIdAtual = -20
            axios.put('/Telas/CadastroSinistros/PutSinistro', this.Sinistro)
            this.EditCancel()
          }
        })
    },
    async Get () {
      const _id = this.id || ''

      const resp1 = await axios.get('/Telas/CadastroSinistros/GetDados/' + _id)

      this.DadosGarantidora = resp1.data.garantidoras
        .filter(x => x.garVisivel)
        .sort((a, b) => a.garNomeEmpresa.localeCompare(b.garNomeEmpresa, 'pt', { sensitivity: 'base' }))

      this.User.tpeid = resp1.data.tpeId
      this.User.garid = resp1.data.garId
      this.User.cusid = resp1.data.cusId
      this.User.pesid = resp1.data.pesId

      this.ConfiguraSinistroGar = resp1.data.garantidoraConfiguracao
      this.ListTipoSinistro = resp1.data.tipoSinistro

      if (this.id) {
        this.Sinistro = resp1.data.sinistro?.[0] ?? null
        console.log('this.Sinistro')
        console.log(this.Sinistro)
        this.selectedTipoSinistro = this.Sinistro.tsnId

        const debitos = resp1.data.sinistroDebito ?? []
        const docs = resp1.data.sinistroDebitoDocumento ?? []

        const docBySdbId = new Map(docs.map(d => [d.sdbId, d]))

        const novaLista = debitos.map(d => {
          const doc = docBySdbId.get(d.sdbId) || null
          return {
            ...d,
            sdbValorDebitoFmt: String(d.sdbValorDebito ?? '').replaceAll('.', ','),
            sdbDtDebitoFmt: d.sdbDtDebito ? moment(d.sdbDtDebito).format('YYYY-MM-DD') : '',
            docNome: doc?.docNome ?? '',
            sddNomeOriginal: doc?.sddNomeOriginal ?? '',
            sddNomeInterno: doc?.sddNomeInterno ?? '',
            sddId: doc?.sddId ?? 0,
            documento: doc
          }
        })

        // 👇 troca por uma NOVA referência (e garante array)
        this.ListaDebitos = [...novaLista]

        this.selectedGarantidora = this.DadosGarantidora.find(x => x.garId == this.Sinistro?.garId) || null

        // se isso for async, aguarde para não sobrescrever estado em seguida
        await this.BuscaImobialiarias?.()
      } else {
        if (this.User.garid != 0) {
          this.selectedGarantidora = this.DadosGarantidora[0] || null
          await this.BuscaImobialiarias?.()
        }
      }

      const resp2 = await axios.get('/Telas/CadastroSinistros/GetByIdModeloContrato')
      this.ModeloContrato = resp2.data

      await this.$nextTick()
    }

  },
  created () {
    this.Get()
  }
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
.gp-claim-form-card { overflow: hidden; border: 1px solid #e1d9cd; border-radius: 14px; }
.gp-claim-form-card > .card-body { padding: 0; }
.gp-claim-form-card :deep(.gp-client-tabs) { padding: 8px 14px 0; border-bottom: 1px solid #e8e1d7; background: #fcfaf7; }
.gp-claim-form-card :deep(.v-tab) { gap: 6px; border-radius: 9px 9px 0 0; }
.gp-claim-section-header,
.gp-claim-info-card__header { display: flex; align-items: center; gap: 11px; border-bottom: 1px solid #e8e1d7; background: #fcfaf7; }
.gp-claim-section-header { padding: 14px 20px; }
.gp-claim-section-header > span,
.gp-claim-info-card__header > span { display: inline-flex; align-items: center; justify-content: center; flex: 0 0 auto; border-radius: 10px; background: #fff0dc; color: #d96f00; }
.gp-claim-section-header > span { width: 36px; height: 36px; }
.gp-claim-section-header h4,
.gp-claim-info-card__header h5 { margin: 0; color: #102a5a; font-size: 13px; font-weight: 800; }
.gp-claim-section-header p,
.gp-claim-info-card__header p { margin: 2px 0 0; color: #778196; font-size: 10px; }
.gp-claim-info-card { height: 100%; overflow: hidden; border: 1px solid #e1d9cd; border-radius: 12px; background: #fff; }
.gp-claim-info-card__header { padding: 11px 14px; }
.gp-claim-info-card__header > span { width: 32px; height: 32px; }
.gp-claim-info-card__body { padding: 16px; }
.gp-claim-info-card__body .texto-mensagem { margin-bottom: 7px !important; color: #4d586d !important; font-size: 11.5px !important; }
.gp-claim-documents-card :deep(.v-table) { margin-top: 8px; border: 1px solid #e8e1d7; border-radius: 10px; }
.gp-claim-form-card :deep(.v-field) { border-radius: 9px; font-size: 12px; }
.gp-claim-form-card :deep(.v-field__input) { min-height: 38px; padding-top: 4px; padding-bottom: 4px; }
.gp-claim-form-card :deep(.v-autocomplete__selection) { transform: translateY(4px); }
@media (max-width: 767.98px) {
    .gp-claim-section-header { padding: 12px 14px; }
    .gp-claim-info-card__body { padding: 13px; }
}
</style>
